// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Loading_wrapper__eLPYA","loader":"Loading_loader__bljzb","tag":"Loading_tag__mSl77","dot":"Loading_dot__UBRS2","slide":"Loading_slide__xc4_f"};